import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import adminApi from '@/lib/adminApi';

const ProtectedAdminRoute = () => {
  const [status, setStatus] = useState('loading');
  const location = useLocation();

  useEffect(() => {
    let mounted = true;

    const checkSession = async () => {
      try {
        await adminApi.get('/admin/me');
        if (mounted) setStatus('authenticated');
      } catch (error) {
        if (mounted) setStatus('unauthenticated');
      }
    };

    checkSession();

    return () => {
      mounted = false;
    };
  }, []);

  if (status === 'loading') {
    return (
      <div className="min-h-screen gradient-bg flex items-center justify-center px-4">
        <div className="bg-white rounded-3xl shadow-2xl px-8 py-10 text-center max-w-md w-full">
          <div className="w-12 h-12 mx-auto mb-4 rounded-full border-4 border-[#FF6F00] border-t-transparent animate-spin" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Checking admin access</h1>
          <p className="text-gray-600">Please wait while we verify your session.</p>
        </div>
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedAdminRoute;
